import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
  import useGetOrganizations from '../../../../../hooks/HR/use-get-organizations.js';
import useGetLocations from '../../../../../hooks/HRSetting/use-get-locations.js';
//  import DataTableComponent from '../../../../../components/DataTable/DataTableComponent.jsx';

const TableSummaryList = ({ SummaryList, toDate, fromDate }) => {
  const [search, setSearch] = useState('');
  const { t, i18n } = useTranslation();
  const [orgName, setOrgName] = useState(null);
  const [LocationName, setLocationName] = useState(null);
  const { loading, OrganizationOptions } = useGetOrganizations();
  const { Locations } = useGetLocations();

  const filteredSearch = SummaryList?.filter((item) => {
    const searchLowerCase = search.toLowerCase();
    return (
      item.employeeNumber?.toLowerCase().includes(searchLowerCase) ||
      item.employeeName?.toLowerCase().includes(searchLowerCase) ||
      item.employeeName2?.toLowerCase().toString().includes(searchLowerCase)
    );
  })
    ?.filter((f) =>
      orgName === null ? true : f?.organizationName === orgName || f.organizationName2 === orgName
    )
    ?.filter((f) =>
      LocationName === null
        ? true
        : f?.locationName === LocationName || f.locationName2 === LocationName
    )
    ?.sort((a, b) => a.absence - b.absence);

  //________________________________

  const convertToMinutes = (time) => {
    if (!time || typeof time !== 'string') return 0; // التحقق من أن القيمة نصية وصحيحة
    const [hours, minutes] = time.split(':').map(Number); // قراءة الساعات والدقائق فقط
    return (hours || 0) * 60 + (minutes || 0); // حساب الوقت بالدقائق فقط
  };

  const columns = [
    { title: t('Name'), key: 'NameAr' },
    { title: t('Name'), key: 'NameEn' },
    // { title: t('Name'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'EmployeeNumber' },
    { title: t('location'), key: 'location' },
    { title: t('خطة الحضـور '), key: 'rotationPlan' },
    { title: t('LATE'), key: 'LATE' },
    { title: t('تأخير (دقيقة)'), key: 'LATEmin' },
    { title: t('ExtraHours'), key: 'ExtraHours' },
    { title: t('ساعات اضافية (دقيقة)'), key: 'ExtraHoursmin' },
    { title: t('Duration'), key: 'Duration' },
    { title: t('DaysAbsence'), key: 'DaysAbsence' },
  ];

  const tableData = filteredSearch?.map((item) => {
    let rowClass;

    return {
      NameAr: item.employeeName2,
      NameEn: item.employeeName,
      EmployeeNumber: item.employeeNumber,
      location: i18n.language === 'en' ? item.locationName : item.locationName2,
      rotationPlan: i18n.language === 'en' ? item.rotationPlanName : item.rotationPlanName2,
      LATE: item.delayS,
      LATEmin: convertToMinutes(item.delayS),

      ExtraHours: item.overTimeS,
      ExtraHoursmin: convertToMinutes(item.overTimeS),
      Duration: item.durationActS,
      DaysAbsence: item.absence,

      rowClass, // استخدم rowClass هنا
    };
  });

  const options = {
    retrieve: true,
    paging: true,
    pageLength: 10,
    searching: false,
    ordering: true,
    lengthChange: true, //
    // info: false, //
    columnDefs: [
      // { orderable: false, targets: 7 }, // تعطيل الترتيب للعمود رقم 7
      { visible: false, targets: [1, 9] }, // إخفاء الأعمدة رقم 3 و 4 افتراضيًا
    ],

    order: [[2, 'desc']],
    responsive: true,
    // dom: "Bfrtip",
    dom:
      "<'row'<'col-sm-12 mb-2 mt-2 text-end'B><'col-sm-6'f>>" + // توزيع الأزرار وحقل البحث في سطر واحد
      "<'row'<'col-sm-12'tr>>" + // الجدول
      "<'row'<'col-sm-5'i><'col-sm-7'p>>", // معلومات الجدول والتنقل بين الصفحات
    buttons: [
      {
        extend: 'colvis',
        className: 'btn btn-outline-theme btn-sm text-end',
        text: localStorage.i18nextLng=== 'ar' ? 'إظهار/إخفاء الأعمدة' : 'Column Visibility',
      },
      {
        extend: 'csv',
        className: 'btn btn-outline-theme btn-sm',
        charset: 'utf-8',
        bom: true, // إضافة BOM لضمان دعم الحروف العربية
        text: localStorage.i18nextLng=== 'ar' ? 'تصدير CSV' : 'Export CSV',
        exportOptions: {
          columns: ':visible', // تصدير الأعمدة المرئية فقط
        },
      },
    ],
  };
  //________________________________

  // const columns = [
  //   { title: t('Name'), key: 'Name' },
  //   { title: t('EmployeeNumber'), key: 'EmployeeNumber' },
  //   { title: t('location'), key: 'location' },
  //   { title: t('Organization'), key: 'Organization', className: 'text-theme' },
  //   { title: t('Duration'), key: 'Duration' },
  //   { title: t('LATE'), key: 'LATE' },
  //   { title: t('ExtraHours'), key: 'ExtraHours' },
  //   { title: t('DaysAbsence'), key: 'DaysAbsence' },
  // ];

  // const tableData = filteredSearch?.map((item) => {
  //   let rowClass;
  //   return {
  //     Name: i18n.language === 'en' ? item.employeeName : item.employeeName2,
  //     EmployeeNumber: item.employeeNumber,
  //     location: i18n.language === 'en' ? item.locationName : item.locationName2,
  //     Organization: i18n.language === 'en' ? item.organizationName : item.organizationName2,
  //     Duration: item.durationActS,
  //     LATE: item.delayS,
  //     ExtraHours: item.overTimeS,
  //     DaysAbsence: item.absence,
  //     rowClass, // استخدم rowClass هنا
  //   };
  // });

  //________________________________

  //________________________________

  return (
    <div>
      <div className="row">
        <div className="col-lg-4 d-flex justify-content-start">
          <div className="input-group mb-1">
            <div className="flex-fill position-relative">
              <div className="input-group">
                <div
                  className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                   >
                  <i className="fa fa-search opacity-5"></i>
                </div>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control ps-35px"
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={t('Search') + ' ...'}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="form-group mb-1">
            <Select
              classNamePrefix="react-select"
              isLoading={loading}
              isSearchable={true}
              isClearable
              options={Locations?.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(option) => {
                setLocationName(option === null ? null : option.label);
              }}
              placeholder={t('location')}
            />
          </div>
        </div>
        <div className="col-lg-4">
          <div className="form-group mb-1">
            <Select
              classNamePrefix="react-select"
              isLoading={loading}
              isSearchable={true}
              isClearable
              options={OrganizationOptions}
              onChange={(option) => {
                setOrgName(option === null ? null : option.label);
              }}
              placeholder={t('Department')}
            />
          </div>
        </div>

        {/* <div className="col-lg-4 text-end ">
          <button
            onClick={exportToExcel}
            className="btn btn-outline-theme text-nowrap rounded-2"
            tabIndex={0}
            aria-controls="datatable"
            type="button">
            <span>
              <i className="fa fa-file-excel fa-fw me-1" /> {t('ExportData')}
            </span>
          </button>
        </div> */}
      </div>

      {/* <NtxTable
          data={tableData || []}
          columns={columns}
          dataPerPage={10}
          theadClass=""
          tableClass="table text-nowrap table-hover "
          // enableSearch
          // showRecordsSelector
        /> */}

      <DataTableComponent
        data={tableData || []}
        columns={columns}
        options={options}
        theadClass=""
        tableClass="table table-hover text-nowrap"
      />
    </div>
  );
};

export default TableSummaryList;

// <tr>
//   <th scope="col">Name</th>
//   <th scope="col">empNo</th>
//   <th scope="col"> transitionDate</th>
//   <th scope="col">fingerprintTimeAct1</th>
//   <th scope="col">fingerprintTimeAct2</th>
//   <th scope="col">durationAct1</th>
//   <th scope="col">dely1</th>
// </tr>
